// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6729c2e1","239":"f8fc903d","453":"ae0cf829","455":"834f4c2d"}[chunkId] + ".chunk.js";
};